import { Routes } from '@angular/router';
import { RoleGuardService as RoleGuard } from './core/services/role-guard.service';
import { IeComponent } from './shared/components/ie/ie.component';
const ɵ0 = {
    admin: [true]
}, ɵ1 = () => import("./admin/admin.module.ngfactory").then(m => m.AdminModuleNgFactory), ɵ2 = () => import("./public/public.module.ngfactory").then(m => m.PublicModuleNgFactory);
const routes = [
    {
        path: 'admin',
        data: ɵ0,
        canActivate: [RoleGuard],
        loadChildren: ɵ1
    },
    {
        path: 'public',
        loadChildren: ɵ2
    },
    {
        path: 'ie',
        component: IeComponent
    },
    {
        path: '',
        redirectTo: 'public',
        pathMatch: 'full'
    },
];
export class AppRoutes {
}
export { ɵ0, ɵ1, ɵ2 };
